export default __webpack_public_path__ + "static/media/pi~zzONzblL.ddc41a4d.svg";